import React from 'react';
import { Link } from 'react-router-dom';
import './Fees.css';

const FEE_DATA = [
  {
    title: 'Single LPA',
    desc: 'Either type',
    fee: '199',
    opg: '92',
    popular: false,
  },
  {
    title: 'Both LPAs for One Person',
    desc: 'Property & Financial + Health & Welfare',
    fee: '349',
    opg: '184',
    popular: true,
  },
  {
    title: 'One Type of LPA for a Couple',
    desc: 'Same type, two people',
    fee: '349',
    opg: '184',
    popular: false,
  },
  {
    title: 'Both Types for a Couple',
    desc: 'Four LPAs total',
    fee: '599',
    opg: '368',
    popular: false,
  },
];

const INCLUDES_LIST = [
  'Personalised advice',
  'Structuring of attorney appointments',
  'Drafting and careful review',
  'Supervised execution guidance',
  'Certificate Provider services (where required - fees apply)',
  'Preparation and submission for registration',
  'Ongoing support during registration',
  'Storage of your original LPA once registered with the Office of Public Guardians (if required)',
  'Additional Certified Copies available (fees apply)',
];

function Fees() {
  return (
    <div className="fees-page">
      {/* ── Hero ── */}
      <section className="fees-hero">
        <div className="fees-hero__inner">
          <div className="fees-hero__breadcrumb">
            <Link to="/">Home</Link>
            <span className="fees-hero__breadcrumb-sep">/</span>
            <span className="fees-hero__breadcrumb-current">Our Fees</span>
          </div>
          <h1 className="fees-hero__title">Our Fees</h1>
        </div>
      </section>

      {/* ── Intro ── */}
      <section className="fees-section fees-section--alt">
        <div className="fees-section__inner">
          <span className="fees-section__label">Transparent Pricing</span>
          <h2 className="fees-section__title">Professional LPA Services</h2>
          <p className="fees-section__desc">
            It is possible to prepare and submit a Lasting Power of Attorney yourself
            using the government's online service and paying the Office of the Public
            Guardian registration fee directly. The current Office of the Public
            Guardian (OPG) registration fee is &pound;92 per LPA (reductions or
            exemptions may apply in certain circumstances). However, errors in drafting
            or execution are common and can result in rejection, delay or future
            complications. At The LPA Company, we provide a full solicitor-led service
            including advice, drafting, correct execution and registration.
          </p>
        </div>
      </section>

      {/* ── Fee Cards ── */}
      <section className="fees-section fees-section--white">
        <div className="fees-section__inner">
          <span className="fees-section__label">Our Fees</span>
          <h2 className="fees-section__title">Fixed fees. No surprises.</h2>

          <div className="fees-cards">
            {FEE_DATA.map((item) => (
              <div
                key={item.title}
                className={`fees-card${item.popular ? ' fees-card--popular' : ''}`}
              >
                {item.popular && <span className="fees-card__badge">Most Popular</span>}
                <h3 className="fees-card__title">{item.title}</h3>
                <p className="fees-card__desc">{item.desc}</p>
                <div className="fees-card__price">
                  <span className="fees-card__amount">&pound;{item.fee}</span>
                  <span className="fees-card__label">Our fee</span>
                </div>
                <div className="fees-card__opg">
                  <span className="fees-card__opg-amount">+ &pound;{item.opg}</span>
                  <span className="fees-card__opg-label">OPG registration fee</span>
                </div>
              </div>
            ))}
          </div>

          {/* Payment Terms */}
          <div className="fees-terms">
            <div className="fees-terms__icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 6v6l4 2" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="fees-terms__content">
              <h3 className="fees-terms__title">Payment Terms</h3>
              <p className="fees-terms__text">
                50% payable on instruction. Balance and OPG fees payable when documents
                are ready for signing and submission.
              </p>
              <p className="fees-terms__text">
                Additional fees may apply for Certification Services and Certified Copies of Documents.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── What Our Service Includes ── */}
      <section className="fees-section fees-section--alt">
        <div className="fees-section__inner">
          <span className="fees-section__label">Full Service</span>
          <h2 className="fees-section__title">What Our Service Includes</h2>
          <p className="fees-section__desc">
            Our fixed fee covers the complete solicitor-led LPA service from initial
            advice through to successful registration.
          </p>

          <ul className="fees-includes">
            {INCLUDES_LIST.map((item) => (
              <li key={item} className="fees-includes__item">
                <span className="fees-includes__check">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17l-5-5" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="fees-includes__text">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="fees-cta">
        <div className="fees-cta__inner">
          <h2 className="fees-cta__title">Ready to get started?</h2>
          <p className="fees-cta__desc">
            Contact us to discuss your requirements and we will provide a clear
            breakdown of the fees applicable to your situation.
          </p>
          <Link to="/contact" className="btn btn-primary">
            Get in Touch
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginLeft: 8 }}>
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Fees;
